import PortalNavbar from "@/components/feature/PortalNavbar";
import PortalFooter from "@/components/feature/PortalFooter";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import Hero from "./components/Hero";
import TodaySection from "./components/TodaySection";
import CategorySection from "./components/CategorySection";
import LatestPreview from "./components/LatestPreview";
import ReviewSection from "./components/ReviewSection";
import SubscribeSection from "./components/SubscribeSection";
import FaqSection from "./components/FaqSection";

const schema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "曝光导航",
  description: "曝光导航今日更新汇总最新爆料与热门排行，聚合综艺影视音乐时尚热点动态与往期回顾。",
  inLanguage: "zh-CN",
  potentialAction: {
    "@type": "SearchAction",
    target: { "@type": "EntryPoint", urlTemplate: "/search?q={search_term_string}" },
    "query-input": "required name=search_term_string",
  },
};

export default function HomePage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Seo
        title="曝光导航 - 今日更新 最新爆料 热门排行 娱乐热点追踪"
        description="曝光导航今日更新汇总最新爆料与热门排行，聚合综艺、影视、音乐、时尚等圈内动态，新料提醒助你实时追踪热点，往期回顾让你随时回看不落伍。"
        keywords="曝光导航,今日更新,最新爆料,热门排行,娱乐热点,动态追踪,往期回顾"
        schema={schema}
      />
      <PortalNavbar />
      <main>
        <Hero />
        <TodaySection />
        <CategorySection />
        <LatestPreview />
        <ReviewSection />
        <SubscribeSection />
        <FaqSection />
      </main>
      <PortalFooter />
      <BackToTop />
    </div>
  );
}